import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { EshopListItemAPI } from '@twisto/api-cms'

import { EshopCard } from 'homepage/components/eshop-card'
import { useAdditionalData } from 'homepage/libs/context'

import * as styles from '../../eshops.styles'

type EshopsByCategoryProps = {
  eshops: EshopListItemAPI[]
  categoryName?: string
}

export const EshopsByCategory = ({
  eshops,
  categoryName,
}: EshopsByCategoryProps) => {
  const { origin } = useAdditionalData()

  return (
    <>
      <Typography css={styles.categoryTitle} variant="h2">
        {categoryName}
      </Typography>

      <div css={[styles.shopsInCategory]}>
        {eshops.map((shop) => (
          <EshopCard
            key={shop.id}
            origin={origin || ''}
            shop={shop}
            variant="compact"
          />
        ))}
      </div>
    </>
  )
}
